// extracted by mini-css-extract-plugin
export default {"container":"AdminForm_container__uRaNR","actions":"AdminForm_actions__O-+1r"};